import { useQuery } from "@tanstack/react-query";
import ApiOrders from "api/orders";
import { IOrderType } from "api/admin";

export function useFolderOrderTypes(folderId: number | undefined | null) {
  return useQuery<IOrderType[]>({
    queryKey: ["folderOrderTypes", folderId],
    queryFn: () => {
      if (!folderId) {
        throw new Error("Survey has no folder assigned");
      }
      return ApiOrders.getOrderTypesForFolder(folderId);
    },
    enabled: !!folderId,
  });
}
